import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR } from "../../../../../helpers/format";
import { IParametro } from "../Create/types/types";

interface Props {
  data?: IParametro;
  title: string;
  onClose: () => void;
}

const Info: React.FC<Props> = (props: Props) => {

  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_parametro ? props.data.id_parametro : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Chave
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.chave || '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Valor
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.valor || '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Unidade
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.unidade || '---'}
            </span>
          </div>
          <div className="flex flex-col w-full col-span-2">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Descrição
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.descricao || '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Ativo
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.ativo ? 'Sim' : 'Não'}
            </span>
          </div>
        </div>
        <div className="w-full grid grid-cols-1 gap-2 gap-y-6 mt-4">
        <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data Modificação
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_historico ? formatDateTimeBR(props.data.data_historico) : '---'}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
